// extracted by mini-css-extract-plugin
export var fadeIn = "_ix-1";
export var modalContent = "_ix-3";
export var overlay = "_ix-0";
export var popoverContent = "_ix-2";
export var results = "_ix-5";
export var searchInputWrapper = "_ix-4";